import React, {useState} from "react";
import styled from "styled-components";


const InformationOption = ({type, prev, next}) => (
    prev ?
        <StyledInformationOption>
            <div className="prev">
                <b>{type}:</b>
                {prev}
            </div>
            <div className="next">
                {next}
            </div>
        </StyledInformationOption>
        : <></>
)


const StyledInformationOption = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: normal;

  .prev {
    font-weight: normal;

    b {
      margin-right: 7px;
    }
  }

  .next {
    font-weight: normal;

  }
`
export default InformationOption